"use client";

// import { ThemeSelector } from '@/components/providers/Theme/ThemeSelector'
import { Icons } from "@/components/shared/icons";
import { Typography } from "@/components/typography";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useTheme } from "next-themes";

export const ModeToggle = () => {
    const { theme, setTheme } = useTheme();

    // <ThemeSelector />
    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button
                    variant="ghost"
                    size="sm"
                    className="size-8 cursor-pointer px-1 focus-visible:border-2 focus-visible:border-gray-300 focus-visible:ring-1 focus-visible:ring-offset-0 dark:focus-visible:border-gray-600"
                >
                    <Icons.sun className="scale-100 rotate-0 transition-all dark:scale-0 dark:-rotate-90" />
                    <Icons.moon className="absolute scale-0 rotate-90 transition-all dark:scale-100 dark:rotate-0" />
                    <span className="sr-only">Toggle theme</span>
                </Button>
            </PopoverTrigger>
            <PopoverContent className="flex flex-col space-y-4">
                <Typography variant="h6">Theme</Typography>
                <Tabs defaultValue={theme}>
                    <TabsList className="w-full">
                        <TabsTrigger value="light" onClick={() => setTheme("light")}>
                            <span className="icon-[tabler--sun] mr-1" />
                            Light
                        </TabsTrigger>
                        <TabsTrigger value="dark" onClick={() => setTheme("dark")}>
                            <span className="icon-[tabler--moon-stars] mr-1" />
                            Dark
                        </TabsTrigger>
                        <TabsTrigger value="system" onClick={() => setTheme("system")}>
                            <span className="icon-[tabler--adjustments-cog] mr-1" />
                            System
                        </TabsTrigger>
                    </TabsList>
                </Tabs>
            </PopoverContent>
        </Popover>
    );
};
